import { Box } from '@mui/material';
import React from 'react';
import * as ReactDOM from 'react-dom';

import { cardClassIdentifier } from '../../Card/sharedCardStyles';

interface OverlayContainerProps {
  children: React.ReactNode;
  overlayRef: HTMLElement | null;
}

export const coverImageChildCID = 'CID-CoverImageChild';

/**
 * Render content in an openlayers overlay.
 * Due to their mouse handling implementation, clicks get fucked up, see the issue for more info
 * https://github.com/openlayers/openlayers/issues/6948
 * @flaky
 */
const OverlayContainer = ({ children, overlayRef }: OverlayContainerProps): JSX.Element | null => {
  if (!overlayRef) {
    return null;
  }

  return ReactDOM.createPortal(
    <Box
      sx={{
        '& div': {
          maxWidth: '25rem',
        },
        [`& .${cardClassIdentifier}`]: {
          maxHeight: '40vh',
          minWidth: '15rem',
          overflow: 'auto',
        },
        [`& .${coverImageChildCID}`]: {
          height: 'initial',
        },
      }}
    >
      <div className="click-ignore">{children}</div>
    </Box>,
    overlayRef,
  );
};

export default OverlayContainer;
